import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { AuthShell, field, goldBtn } from "@/pages/Login";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    if (password !== confirm) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      toast.success("Password updated — please sign in");
      nav("/login");
    } catch (e) {
      toast.error(formatErr(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <AuthShell tag="Members" title="Invalid link" footer={<Link to="/forgot" className="text-[#D4AF37]">Request a new link</Link>}>
        <p className="text-white/50 text-sm">This reset link is missing or malformed.</p>
      </AuthShell>
    );
  }

  return (
    <AuthShell tag="Members" title="New password" footer={<Link to="/login" className="text-[#D4AF37]">Back to sign in</Link>}>
      <input data-testid="reset-password" type="password" placeholder="New password (6+ characters)" value={password}
        onChange={(e) => setPassword(e.target.value)} className={field} />
      <input data-testid="reset-confirm" type="password" placeholder="Confirm new password" value={confirm}
        onChange={(e) => setConfirm(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} className={field} />
      <button data-testid="reset-submit" onClick={submit} disabled={busy} className={goldBtn}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}
      </button>
    </AuthShell>
  );
}
